import { Link } from "react-router-dom";
import { useAdmin } from "../../../contexts/AdminContext";

export default function HowItWorks() {
  const { settings } = useAdmin();
  const steps = settings.howItWorksSteps;

  return (
    <section id="how-it-works" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Header Section */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="inline-flex items-center gap-2 mb-6">
            <span className="h-px w-8 bg-slate-200"></span>
            <span className="uppercase text-slate-400 text-[10px] font-black tracking-[0.2em] relative">
              Teilnahme-Prozess
            </span>
            <span className="h-px w-8 bg-slate-200"></span>
          </div>
          <h2 className="font-playfair text-4xl md:text-6xl font-black text-slate-900 leading-[1.1] tracking-tight mb-6">
            Wie es <span className="italic font-medium text-slate-500">funktioniert</span>
          </h2>
          <p className="text-slate-500 text-lg md:text-xl font-medium leading-relaxed">
            Die Teilnahme an der größten Verlosung des Jahres war noch nie so einfach, sicher und transparent.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-16">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group">
              {/* Desktop Connector Line */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-px border-t border-dashed border-slate-200 z-0"></div>
              )}
              
              <div className="relative z-10 flex flex-col items-center text-center">
                <div className="w-24 h-24 bg-slate-50 rounded-full flex items-center justify-center border-4 border-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] mb-8 group-hover:bg-slate-900 group-hover:text-white transition-all duration-500 relative">
                  <i className={`${step.icon} text-3xl text-slate-400 group-hover:text-white transition-colors duration-500`}></i>
                  
                  {/* Step Number Badge */}
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center text-[10px] font-black shadow-lg shadow-primary/30">
                    {step.num}
                  </div>
                </div>
                
                <h3 className="font-black text-slate-900 text-lg mb-3 uppercase tracking-tight">{step.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed font-medium px-4">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <Link
            to="/forfaits"
            className="inline-flex items-center justify-center gap-3 bg-slate-900 text-white font-black px-10 py-5 rounded-full transition-all duration-300 hover:bg-primary shadow-xl shadow-slate-900/20 hover:shadow-primary/30 hover:-translate-y-1 text-sm uppercase tracking-widest group"
          >
            JETZT STARTEN
            <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>

      </div>
    </section>
  );
}
